//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { events, UrlService } from "@nuskin/ns-util";
import { UserService } from "@nuskin/ns-account";
import "@nuskin/ns-core-styles/src/dist/main.css";

export default {
  name: "NsMessageAction",
  props: {
    /**
     * Text to display on button
     */
    actionLabel: {
      type: String,
      default: ""
    },
    /**
     * Pass in 'login' to perform login redirect instead of url redirect
     */
    actionType: {
      type: String,
      default: null,
      validator(value) {
        return ["login"].includes(value);
      }
    },
    /**
     * URL to link too when action button clicked
     */
    actionUrl: {
      type: String,
      default: ""
    },
    /**
     * Message to be displayed
     */
    message: {
      type: String,
      default: ""
    },
    /**
     * Text to display on secondary action
     */
    secondaryActionLabel: {
      type: String,
      default: ""
    },
    /**
     * URL for secondary action
     */
    secondaryActionUrl: {
      type: String,
      default: ""
    },
    /**
     * Flag to use an event to perform secondary action
     */
    useEventForSecondaryAction: Boolean
  },
  data() {
    return {
      /**
       * Used to go to a specific URL if override specified
       */
      secondaryActionPDPSKU: ""
    };
  },
  computed: {
    hideAction() {
      return this.actionType === "login" && UserService.isLoggedIn();
    },
    hideSecondaryAction() {
      return !this.secondaryActionLabel;
    },
    secondaryActionHref() {
      return this.useEventForSecondaryAction || !this.secondaryActionUrl
        ? `${UrlService.getAemLocaleUrl()}products/product.${
            this.secondaryActionPDPSKU
          }.html`
        : this.secondaryActionUrl;
    }
  },
  mounted() {
    events.subscribe(events.shop.SHOW_EXCLUSIVE_OFFER_DETAILS, item => {
      if (item && item.sku) {
        this.secondaryActionPDPSKU = item.sku;
      }
    });
  },
  methods: {
    /**
     * Request login
     */
    handleLoginRequest() {
      events.publish(events.authentication.REQUEST_FOR_LOGIN);
    }
  }
};
